<template>
  <div :class="classes">
    <slot></slot>
  </div>
</template>

<script>
import themeMixins from '../../mixins/themeMixins';
export default {
  mixins: [themeMixins],
};
</script>
